<script>
  import {getContext, onMount} from 'svelte';
  import {goto} from '@sapper/app';
  import {fixLink$} from '@/store';
  import {spotMarkets$, sortParams$, marginMarkets$} from '@/modules/markets/streams-market';
  import {memeMarket$, memeQuery$} from '@/streams/config/MemeX';
  import Search from '@/widgets/Search.svelte';
  import {marketUtil} from '@/modules/markets/util2';
  import {coinUtil} from '@/helper';
  import {PerpetualType} from '@/modules/markets/enum';
  import lang from '../../Header.lang';

  const LG = getContext('LG');

  let searchKey = '';
  let contractType = PerpetualType.USDS;
  let advancedFilter = {
    volume: {
      min: 0,
      max: Infinity,
    },
    change: {
      min: -Infinity,
      max: Infinity,
    },
  };

  export let name;
  export let categoryId;
  export let innerHeight = 405

  $: isMMX = name === 'MemeTrading';
  $: dataSource = (name === 'spot_trading' && $spotMarkets$) || (name === 'margin_trading' && $marginMarkets$) || [];
  $: markets = isMMX ? $memeMarket$ : marketUtil.genSpotMarketsForAdvance(dataSource, $sortParams$, advancedFilter, categoryId, 'USDT', searchKey);

  onMount(() => {
    if ($memeMarket$.length < 10) {
      memeQuery$.next({
        orderBy: 'Gainers',
        pageNum: 1,
        // 取大，主要给header mmx搜索拿全量数据使用
        pageSize: 10,
      });
    }
  });

  function getSearchKey(e) {
    searchKey = e.detail || '';
    if (isMMX) {
      const query = {
        pageNum: 1,
        // 取大，主要给header mmx搜索拿全量数据使用
        pageSize: 10,
      }
      if (searchKey) {
        query.searchBy = searchKey
      } else {
        query.orderBy = 'Gainers';
      }
      memeQuery$.next({...query});
    }
  }

  function handleToTrade(info) {
    if (info.tradeLink) {
      goto(info.tradeLink);
    }
  }
</script>

<style lang="scss">
  .wrap {
    box-sizing: border-box;
    padding: 16px;
    width: 344px;
    height: 405px;
    background: rgba(21, 21, 21, 0.85);
    cursor: default;
    backdrop-filter: blur(10px);
    border-bottom-right-radius: 12px;
  }
  .search-box {
    padding: 0 12px;
  }
  .wrap :global(.search input) {
    color: #fff;
    caret-color: #fff;
  }
  .market {
    overflow-y: auto;
    .c-gray {
      color: #888b94;
    }
    li {
      padding: 12px;
      &:hover {
        background: rgba(255,255,255, 0.06);
      }
    }
    .gap-4 {
      gap: 4px;
    }
  }
</style>

<div class="wrap df fdc" style="height: {innerHeight}px">
  <div class="search-box">
    <Search on:change={getSearchKey} placeholder={LG(lang.Search)} />
  </div>
  <div class="f1 mt16 sv market">
    {#if !!markets.length}
      <ul>
        {#each markets as market}
          {#if isMMX}
            <li class="df aic jcsb TW cp br8" on:click={handleToTrade.bind(null, market)}>
              <div class="df aic">
                <img src={market.logoUrl || ''} onerror="this.src='https://img.phemex.com/v1/a4afa886-3400-4962-859d-bba075cc0570/defult-coin.svg'" alt={market.fullNamefullName} width="28" height="28" style="border-radius: 50%; object-fit: contain; background: #2c2c2c;" />
                <span class="ml12">{market.coin}</span>
              </div>
              <div class="df fdc aife gap-4">
                <span>{market.price}</span>
                <span class:up={market.priceChangePct24h > 0} class:down={market.priceChangePct24h < 0}>{market.priceChangePct24hDisplay}</span>
              </div>
            </li>
          {:else}
            <li class="df aic jcsb TW cp br8" on:click={handleToTrade.bind(null, market)}>
              <div class="df aic">
                <img src={coinUtil.getUrl(market.baseCurrency)} alt={market.baseCurrency} width="28" height="28" />
                <span class="ml12">{market.pairName}</span>
              </div>
              <div class="df fdc aife gap-4">
                <span>{market.close}</span>
                <span class:up={market.changePercent > 0} class:down={market.changePercent < 0}>{market.changePercentStr}</span>
              </div>
            </li>
          {/if}
        {/each}
      </ul>
    {:else}
      <div class="f16 fw3 TW wp100 df aic jcc c-gray" style="height: 200px">{LG(lang.NoData)}</div>
    {/if}
  </div>
</div>
